// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1GZ1N","bigColWidth":"Table_bigColWidth__2zb4G","biggerColWidth":"Table_biggerColWidth__3d-S1","row":"Table_row__WL06t","col":"Table_col__3OuN0"};